/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RecentInputs */

const en_recent = /** @type {(inputs: RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent`)
};

const id_recent = /** @type {(inputs: RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbaru`)
};

/** @type {(inputs: RecentInputs) => LocalizedString} */
const es_recent = en_recent;

/** @type {(inputs: RecentInputs) => LocalizedString} */
const fr_recent = en_recent;

/** @type {(inputs: RecentInputs) => LocalizedString} */
const de_recent = en_recent;

/** @type {(inputs: RecentInputs) => LocalizedString} */
const ja_recent = en_recent;

/** @type {(inputs: RecentInputs) => LocalizedString} */
const zh_recent = en_recent;

/** @type {(inputs: RecentInputs) => LocalizedString} */
const ar_recent = en_recent;

/** @type {(inputs: RecentInputs) => LocalizedString} */
const it_recent = en_recent;

/** @type {(inputs: RecentInputs) => LocalizedString} */
const ru_recent = en_recent;

/** @type {(inputs: RecentInputs) => LocalizedString} */
const pt_recent = en_recent;

/** @type {(inputs: RecentInputs) => LocalizedString} */
const ko_recent = en_recent;

/**
* | output |
* | --- |
* | "Recent" |
*
* @param {RecentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const recent = /** @type {((inputs?: RecentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RecentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recent(inputs)
	if (locale === "es") return es_recent(inputs)
	if (locale === "fr") return fr_recent(inputs)
	if (locale === "de") return de_recent(inputs)
	if (locale === "ja") return ja_recent(inputs)
	if (locale === "zh") return zh_recent(inputs)
	if (locale === "ar") return ar_recent(inputs)
	if (locale === "id") return id_recent(inputs)
	if (locale === "it") return it_recent(inputs)
	if (locale === "ru") return ru_recent(inputs)
	if (locale === "pt") return pt_recent(inputs)
	return ko_recent(inputs)
});